<template>
    <component
      :is="componentType"
      v-bind="$attrs"
      class="maz-btn"
      :class="[
        classes,
        {
          hidden: loading
        },
        (justifyStart ? 'maz-justify-start' : null)
      ]"
      :disabled="isLink ? null : isDisabled"
      @click="handleClick($event)"
      @mouseenter="emitMouseEnter($event)"
      @mouseleave="emitMouseLeave($event)"
      @focus="emitFocus($event)"
      @blur="emitBlur($event)"
    >

      <slot />

      <!-- Add your button text here -->
      <div
        v-if="loading"
        class="maz-btn__spinner maz-flex maz-flex-center"
      >
        <MazSpinner
          :size="25"
          :color="color"
        />
      </div>
    </component>
</template>

<script>
import { MazSpinner } from 'maz-ui'

export default {
  name: 'CoreButton',
  components: {
    MazSpinner
  },
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    type: {
      type: String,
      default: 'button'
    },
    size: {
      type: String,
      default: 'sm'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    noShadow: {
      type: Boolean,
      default: false
    },
    justifyStart: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    componentType () {
      const { href, to } = this.$attrs
      if (href) return 'a'
      else if (to) return 'router-link'
      return 'button'
    },
    isLink () {
      return this.componentType === 'a'
    },
    isDisabled () {
      const { disabled, loading } = this
      return loading || disabled
    },
    classes () {
      const { color, size, outline, rounded, active, block, noShadow } = this
      return [
        ...(color ? [`maz-btn--${color}`] : [null]),
        ...(size ? [`maz-btn--${size}`] : [null]),
        ...(outline ? [`maz-btn--${color}--outline`] : [null]),
        ...(rounded ? ['maz-btn--rounded'] : [null]),
        ...(block ? ['maz-btn--block'] : [null]),
        ...(active ? ['maz-active'] : [null]),
        ...(noShadow ? ['maz-no-shadow'] : [null])
      ]
    }
  },
  methods: {
    handleClick (e) {
      this.$emit('click', e)
    },
    emitMouseEnter (e) {
      this.$emit('mouseenter', e)
    },
    emitMouseLeave (e) {
      this.$emit('mouseleave', e)
    },
    emitFocus (e) {
      this.$emit('focus', e)
    },
    emitBlur (e) {
      this.$emit('blur', e)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/styles/_variables";
.maz-btn {
  height: 35px;
  &:disabled {
    background: $btn-disabled-background-color;
    color: white;
  }
  &.hidden {
    color: transparent
  }
}
</style>
